export default {
    scheduled: {
        id: 1,
        text: 'Pendiente',
        type: 'warning'
    },
    in_progress: {
        id: 2,
        text: 'En progreso',
        type: 'warning'
    },
    success: {
        id: 3,
        text: 'Exitosa',
        type: 'success'
    },
    cancelled: {
        id: 4,
        text: 'Cancelada',
        type: 'danger'
    },
    failure: {
        id: 5,
        text: 'Fallida',
        type: 'danger'
    },
    ext_pending: {
        id: 6,
        text: 'Pendiente Externo',
        type: 'warning'
    },
    ext_in_progress: {
        id: 7,
        text: 'Externo en progreso',
        type: 'warning'
    },
    active: {
        id: 8,
        text: 'Activo',
        type: 'success'
    },
    inactive: {
        id: 9,
        text: 'Inactivo',
        type: 'danger'
    },
    recovery: {
        id: 10,
        text: 'Recuperar',
        type: 'warning'
    },
    pending: {
        id: 11,
        text: 'Pendiente',
        type: 'warning'
    }
};
